import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl';
import withNavigate from '../../components/common/withNavigate'
import Banner from '../../components/common/Banner';

function Dashboard(props) {
  const { user } = props;
  const [shouldNavigate, setShouldNavigate] = useState(false);

  // NOTE: This is related to 'Require password change on first login' setting, maybe reintroduced later.
  /**
   * Check if user is activated. If not, redirect to password reset page.
   */
  // useEffect(() => {
  //   if (user.status === 0 || user.status === '0') {
  //     console.log('User has not been activated yet, redirecting to password reset page.');
  //     setShouldNavigate(true);
  //   }
  // }, [user]);

  // useEffect(() => {
  //   if (shouldNavigate) {
  //     props.navigate('/activate');
  //   }
  // }, [shouldNavigate, props]);
  
  return (
    <div>
      <main>
        <div className='title'><FormattedMessage id="DASHBOARD" defaultMessage="Dashboard"/></div>
        <Banner />
        {/* <div>Version: {process.env.REACT_APP_VERSION}</div>
        <div>Account ID: {this.props.user.email} ({this.props.user.id})</div>
        <div>CMSes: 
          <div style={{marginLeft: '20px'}}>
            {this.state.cmses.map((cms)=>{
              return <div>{cms.name} ({cms.id})</div>
            })}
          </div>
        </div>
        <div>Company ID: {this.props.user.account.companyName} ({this.props.user.account.id})</div>
        <div>With roles: 
          {' ' + this.props.user.roles.map((role) => {
            return role.name
          }).join(', ')}
        </div>
        <div>With base permissions: 
          {' ' + this.props.user.permissions.map((permission)=>{
            return permission.name
          }).join(', ')}
        </div>
        {this.props.user.permissions.find(permission => permission.id === constants.permissionIds.support)
          && 
          <div>
            <div>
              Receivers per Product:
              <div style={{marginLeft: '20px'}}>
                {this.receiversPerProduct()}
              </div>
            </div>
            <div>Total receivers: {this.state.receiversByModel.reduce((prev, model)=>{return prev + parseInt(model.count)}, 0)}</div>
            <div>
              Customers who have registered receivers: {this.state.customersRegisteredRx}
            </div>
          </div>
        } */}
      </main>
    </div>
)
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps)(withNavigate(Dashboard))
